import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-subscription-paln-loading',
  standalone: true,
  imports: [SkeletonModule],
  templateUrl: './subscription-paln-loading.component.html',
  styleUrl: './subscription-paln-loading.component.scss'
})
export class SubscriptionPalnLoadingComponent implements OnInit, OnDestroy {
  itemsPerView = signal<number>(3); // Number of skeleton cards to show based on viewport width
  private resizeListener: () => void; // Window resize listener to recalculate itemsPerView

  /**
   * Initialize responsive behavior and attach resize listener
   */
  ngOnInit(): void {
    this.updateItemsPerView();
    this.resizeListener = () => {
      this.updateItemsPerView();
    };
    window.addEventListener('resize', this.resizeListener);
  }

  /**
   * Cleanup resize listener on component destruction
   */
  ngOnDestroy(): void {
    if (this.resizeListener) {
      window.removeEventListener('resize', this.resizeListener);
    }
  }

  /**
   * Build an array of the desired length to drive skeleton item rendering
   * @returns array of indexes with length equal to itemsPerView
   */
  getSkeletonItems(): number[] {
    return Array.from({ length: this.itemsPerView() }, (_, index) => index);
  }

  /**
   * Determine how many skeleton cards to display based on current viewport width
   * - <= 767px: 1 item
   * - 768px - 1125px: 2 items
   * - > 1125px: 3 items
   */
  private updateItemsPerView(): void {
    const width = window.innerWidth;
    if (width <= 767) this.itemsPerView.set(1);
    else if (width <= 1125) this.itemsPerView.set(2);
    else this.itemsPerView.set(3);
  }
}
